var getData = require('../GetData/GetData').GetData;
var getMeta = require('../GetMeta/GetMeta').GetMeta;

var metaKeyAttrKey = 'data-meta2';
var dataKeyAttrKey = 'data-data2';

// function roundToTwo(num) {
//     return +(Math.round(num + "e+2") + "e-2");
// }

function numberFormat(number, dec, dsep, tsep) {
  if (isNaN(number) || number == null) return '';

  number = number.toFixed(~~dec);
  tsep = typeof tsep == 'string' ? tsep : ',';

  var parts = number.split('.'),
    fnums = parts[0],

    decimals = parts[1] ? (dsep || '.') + parts[1] : '';

    if (decimals == ',00' || decimals == '.00') {
        return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep);
    } else {
        return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
    }
}

var CalculatedStatDisplay = function() {
    $('.stat-content').each(function(dataEntryElementIndex, dataEntryElement) {

        //console.log('HTML Item: ', dataEntryElement);

        var metaKey = $(dataEntryElement).attr(metaKeyAttrKey);
        var dataKey = $(dataEntryElement).attr(dataKeyAttrKey);

        var data = window[dataKey];
        var meta = window[metaKey];

        // 1. STEP: get data from URL or embedded
        var jsonData = getData(data);
        var jsonMeta = meta.stat.headers;

        // 2. STEP: Check if key exist in data
        var isDataValid = true;
        for (var j = 0; j < jsonMeta.length; j++) {
            var obj1 = jsonMeta[j];
            var value = obj1.key;

            if (value in jsonData[0]) {
                // Do nothing
                isDataValid = true;
            } else {
                var content = '<div class="alert alert-info"> ' +
                    'Napaka, ki se je zgodila je povezana na ključ <strong>' + value + '</strong>, ki ne obstaja v zadani podatkovni vir.' +
                    '</div>' +
                    '<div class="no-entries">' +
                    '<i class="fa fa-info" aria-hidden="true"></i>' +
                    'Statistika ni mogoče prikazati.' +
                    '</div>';

                $(".row.stat-content").append(content);

                isDataValid = false;
                return true;
            }
        }

        // 3. STEP: Built div elements from processed Data
        if (isDataValid) {

            for (var a = 0; a < jsonMeta.length; a++) {

                var obj2 = jsonMeta[a];

                var metaKey = obj2['key'];
                var attrUnit = obj2.unit;
				var attrColor = obj2.color;
                var attrFormat = obj2.format;
                var attrDecimals = attrFormat[2];
                var attrDecimalSeparator = attrFormat[1];
                var attrOrderSeparator = attrFormat[0];
                var attrSubtext = obj2.subtext;
                var attrIcon = obj2.icon;
                var attrLink = obj2.link;
                var attrMetacontent = obj2.meta_html_content;
                var random = Math.floor((Math.random() * 100000000));

                _.each(jsonData[0], function(value, key, obj) {

                    var dataKey = key;

                    if (dataKey == metaKey) {

                        if (attrIcon) {
                            var showIcon = '<div class="stat-icon">' +
                                '<span class="glyphpro glyphpro-' +
                                attrIcon +
                                '"></span>' +
                                '</div>';
                        } else {
                            var showIcon = '';
                        }

                        if (attrLink == 'true') {
                            var showLink = '<a class="stat-link" data-toggle="modal" data-target="#modal_' +
                                random +
                                '">' +
                                '<span class="glyphpro glyphpro-plus"></span>' +
                                '</a>';

                            var modal = '<div class="row stat-modal">' +
                                '<div class="modal fade mymodalfade" id="modal_' +
                                random +
                                '" tabindex="-1" role="dialog" style="display: none;">' +
                                '<div class="modal-dialog">' +
                                '<div class="modal-content">' +
                                '<div class="modal-header">' +
                                '<button type="button" class="close" data-dismiss="modal">&times;</button>' +
                                '<h4 class="modal-title">' +
                                attrSubtext +
                                '</h4>' +
                                '</div>' +
                                '<div class="modal-body">' +
                                '<div class="modal-stat">' +
                                '<span class="modal-stat-data ' + attrColor[0] + '">' +
                                numberFormat(obj[metaKey], attrDecimals, attrDecimalSeparator, attrOrderSeparator) +
                                '</span>' +
                                '<span class="modal-stat-value">' + '&nbsp;' +
                                attrUnit +
                                '</span>' +
                                '</div>' +
                                '<p>' +
                                attrMetacontent +
                                '</p>' +
                                '</div>' +
                                '</div>' +
                                '</div>' +
                                '</div>' +
                                '</div>';
                        } else {
                            var showLink = '';
                            var modal = '';
                        }

                        var content = '<div class="box-row">' +
                            '<div class="col-sm-12 box-row-first">' +
                            showIcon +
                            '<span class="stat-data ' + attrColor[0] + '">' +
                            numberFormat(obj[metaKey], attrDecimals, attrDecimalSeparator, attrOrderSeparator) +
                            '</span>' +
                            '<span class="stat-value">' + '&nbsp;' +
                            attrUnit +
                            '</span>' +
                            '</div>' +
                            '<div class="col-sm-12 box-row-second">' +
                            showLink +
                            '<p class="stat-subtext">' +
                            attrSubtext +
                            '</p>' +
                            '</div>' +
                            '</div>';

                        $(dataEntryElement).find('.horizontal').append(content);
                        $(dataEntryElement).find('.vertical').append(content);
                        $(dataEntryElement).after(modal);
                        return false;

                    } else {
                        return true;
                    }
                })
            }
        }
    });
}

$(document).ready(function() {
    CalculatedStatDisplay();
    $('.vertical').find('.box-row').wrap( "<div class='col-xs-12' />");
    $('.horizontal').find('.box-row').wrap( "<div class='col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12' />");
});

module.exports = CalculatedStatDisplay;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CalculatedStatDisplay/CalculatedStatDisplay.js
// module id = 23
// module chunks = 0